import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_11396_11745)">
          <path
            d="M2 3.99984C2 3.64622 2.14048 3.30708 2.39052 3.05703C2.64057 2.80698 2.97971 2.6665 3.33333 2.6665H12.6667C13.0203 2.6665 13.3594 2.80698 13.6095 3.05703C13.8595 3.30708 14 3.64622 14 3.99984C14 4.35346 13.8595 4.6926 13.6095 4.94265C13.3594 5.19269 13.0203 5.33317 12.6667 5.33317H3.33333C2.97971 5.33317 2.64057 5.19269 2.39052 4.94265C2.14048 4.6926 2 4.35346 2 3.99984Z"
            stroke="#606F85"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.3335 5.3335V12.0002C3.3335 12.3538 3.47397 12.6929 3.72402 12.943C3.97407 13.193 4.31321 13.3335 4.66683 13.3335H11.3335C11.6871 13.3335 12.0263 13.193 12.2763 12.943C12.5264 12.6929 12.6668 12.3538 12.6668 12.0002V5.3335"
            stroke="#606F85"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M6.6665 8H9.33317" stroke="#606F85" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_11396_11745">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
